import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import "../css/servicesfont.css";
const Medicalbillingsys = () => {
  return (
    <MDBContainer fluid className="p-4">
      <div className="mx-4 mx-md-5 mx-xl-6">
        <div className="row">
          <div className="col-12">
            <div className="section-title mb-4 pb-2">
              <h1 className="title mb-4 AcerhealthTextPurple text-center fomtsizetest" style={{ fontFamily: 'Lora, serif' }}>
             Denial Management Services in the USA
              </h1>
           
              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
               Claim denials remain a major revenue challenge for U.S. healthcare practices, often delaying reimbursements and increasing administrative workload.
                AcerHealth provides denial management services in the USA designed to help healthcare organizations identify denial root causes, recover lost
                 revenue, and prevent recurring claim issues. Our structured denial management approach aligns with U.S. payer requirements, compliance 
                 standards, and reimbursement models—allowing practices to reduce denial rates, improve cash flow, and maintain financial stability 
                 without overburdening internal teams.
              </p>
            

            </div>
          
          </div>
        </div>
      </div>
    </MDBContainer>
  );
};
export default Medicalbillingsys;
